import type {
    Inform,
    LifeStyle,
    MedicalHistory,
    MRATreatment,
    OsasEvaluationData,
    PAPTreatment,
    Policy,
    SPTTreatment,
} from '@common/validation/customControls/osas/osasEvaluationSchemas/types';

export const initialLifeStyleTreatmentData: LifeStyle = {
    patientFollowsLifestylePolicy: null,
};

export const initialMRATreatmentData: MRATreatment = {
    patientFollowsMraPolicy: null,
};

export const initialSPTTreatmentData: SPTTreatment = {
    sptAverageUse: null,
    sptNightsWithSupport: null,
    sptRemark: null,
    sptReportEndDate: null,
    sptReportStartDate: null,
    supinePositionFrom: null,
    supinePositionTo: null,
};

export const initialPressure = { unit: null, value: null };

export const initialPAPTreatmentData: PAPTreatment = {
    centralApnea: null,
    cheyneStokes: null,
    extraValuesReport: null,
    obstructiveApnea: null,
    oxygenSaturation: null,
    pAhi3Percent: null,
    papAverageUse: null,
    papNightsWithSupport: null,
    papReportEndDate: null,
    papReportStartDate: null,
    pressureApapMaximum: { unit: null, value: null },
    pressureApapMinimum: { unit: null, value: null },
    pressureApapNinetyfive: { unit: null, value: null },
    pressureCpap: { unit: null, value: null },
    pressureEpap: { unit: null, value: null },
    pressureIpap: { unit: null, value: null },
    type: null,
};

const initialMedicalHistoryData: MedicalHistory = {
    complaintBurden: null,
    hadContactWithPatient: true,
    medicalHistory: null,
    remark: null,
    therapyStartDate: null,
    trialPeriod: null,
};

const initialiPolicyData: Policy = {
    followUpEvaluationWeeks: null,
    policy: null,
};

const initialInformData: Inform = {
    shouldNotifyGeneralPractitioner: null,
};

export const initialTreatmentChoiceData = {
    MRA: false,
    PAP: false,
    SPT: false,
    lifestyle: false,
};

export const initialData: OsasEvaluationData = {
    allTreatments: [],
    assets: [],
    treatingPhysicianPractitionerId: null,
    treatmentChoice: initialTreatmentChoiceData,
    ...initialLifeStyleTreatmentData,
    ...initialMRATreatmentData,
    ...initialSPTTreatmentData,
    ...initialPAPTreatmentData,
    ...initialMedicalHistoryData,
    ...initialiPolicyData,
    ...initialInformData,
};
